import { Injectable } from '@angular/core';
import { castArray } from 'lodash';
import { webSocket, WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';

import { TokenService } from '../auth';
import { EnvironmentService } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly tokenService: TokenService
  ) {}

  async connect<T>(url: string, config?: Omit<WebSocketSubjectConfig<T>, 'url'>): Promise<WebSocketSubject<T>> {
    const protocol = config?.protocol ? castArray(config.protocol) : [];
    const token = await this.tokenService.checkAndGetNewToken();

    if (token) {
      protocol.push('json', `Bearer${token}`);
    }

    return webSocket({
      url: this.environmentService.socketURL + url,
      protocol,
      ...config
    });
  }
}
